import React from 'react';
import {
    withRouter,
} from "react-router-dom"


import {
    withStyles,
    Grid,
    Typography,
    ListItem,
    ButtonBase,
    ListItemSecondaryAction,
    ListItemIcon,
    Divider,
    List,
    Snackbar,

} from '@material-ui/core';
import MySnackbarContentWrapper from '../../component/mysnackbar';
import Apis from '../../network/Apis';
import MBack from '../view/MBack';
import DeviceEventEmitter, { EventName } from '../../control/event';
import copy from 'copy-to-clipboard';
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';

const ICON1 = require("../../images/icons/walleticon0.png");
const ICON2 = require("../../images/icons/walleticon1.png");
const ICON3 = require("../../images/icons/walleticon2.png");
const ICON4 = require("../../images/icons/walleticon3.png");
const ICON5 = require("../../images/icons/walleticon4.png");


const MENU_LIST2 = [
    {
        title: '每日登录', icon: ICON1,
        content: '奖励+2球币',
    },
    {
        title: '关注一场赛事', icon: ICON2,
        content: '奖励+4球币',
    },
    {
        title: '主播互动', icon: ICON3,
        content: '奖励+8球币',
    },
    {
        title: '邀请好友', icon: ICON4,
        content: '奖励+100球币',
    },
    // {
    //     title: '绑定手机', icon: ICON5,
    //     content: '奖励+50球币',
    // },
];

class WalletDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            taskData:[],
            snackmessage: '',
            snackvariant: 'info',
        };
        this._onPayClick = this._onPayClick.bind(this);
        this._onGetClick = this._onGetClick.bind(this);
        this._getTaskStatus = this._getTaskStatus.bind(this);
        this._getTaskStatus();
    }

    _onPayClick() {
        this.props.history.push('/shopdialog')
    }

    _onGetClick() {

    }

    _onSnackClosed = () => {
        this.setState({ snackopened: false, });
    }

    _onListItemClick(n)
    {   
        if(this.state.taskData.length < n+1)
        {
            return;
        }
        if (this.state.taskData[n].task_status == 1)
        {
            this._encryptionTaskEnd(n);
        }
        else if (this.state.taskData[n].task_status == 0)
        {
            if(n == 1)
            {
                AppUtils.setStorageItem(AppUtils.SUBSCRIBE_INDEX, 3);
                this.props.history.push('/');
                // DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 3);
            }
            else if(n == 2)
            {
                AppUtils.setStorageItem(AppUtils.MAIN_PAGE_INDEX_KEY, 2);
                // DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 2);
                this.props.history.push('/');
                // DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 2);
            }
            else{
                if(copy(AppData.ShareUrl)){
                    this.setState({ snackopened: true, snackmessage: '分享链接已复制' });
                }else{
                    this.setState({ snackopened: true, snackmessage: '分享链接复制失败' });
                }
            }
        }
        
    }

    _encryptionTaskEnd = async (n) => {
        let result = await Apis.encryptionTaskEnd(this.state.taskData[n].id);
        // console.log('encryptionTaskEnd', result);
        if (result.code == 200) {
            this.state.taskData[n].task_status = 2;
            this.setState({taskData:result.data});
        }
        else {

        }
    }

    _getTaskStatus = async () => {
        let result = await Apis.encryptionTask();
        console.log('_getTaskStatus', result);
        if (result.code == 200) {
            // this.state.taskData = result.data;
            this.setState({taskData:result.data});
        }
        else {

        }
    }

    render() {
        const { classes } = this.props;
        const { taskData,snackopened, snackvariant, snackmessage } = this.state;
        let MenuData = MENU_LIST2;
        if (taskData.length > 0)
        {
            taskData.forEach((element,index) => {
                if (element.task_status == 0)
                {
                    element['btn'] = classes.taskBtn;
                    element['name'] = '做任务';
                    if(index == 0)
                    {
                        element['btn'] = classes.taskBtn1;
                        element['name'] = '领取';
                    }
                } else if (element.task_status == 1)
                {
                    element['btn'] = classes.taskBtn1;
                    element['name'] = '领取';
                } else {
                    element['btn'] = classes.taskBtn2;
                    element['name'] = '已完成';
                }
            });
        }
        
        return (
            <MBack title="我的钱包">
                <Grid container direction='row' style={{ height: 10 }}></Grid>
                <Grid container justify="center">
                    <Grid container className={classes.img} justify="center" alignItems="center">
                        <Grid container style={{ width: "49.5%" }} justify="center" direction='column' alignItems='center'>
                            <Typography style={{ color: "#E3E3E3", fontSize: 12 }}> 我的球币 </Typography>
                            <Typography style={{ color: "#FFFFFF", fontSize: 'x-large' }}> {AppData.me.Coin} </Typography>
                            <ButtonBase
                                className={classes.sureBtn}
                                onClick={() => this._onPayClick()}
                            >充 值</ButtonBase>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.menuBox}>
                    <List style={{ width: '100%' }}>
                        {
                            MenuData.map((data, n) => (
                                <ListItem key={n + ''} disableRipple button onClick={() => this._onListItemClick(n)}>
                                    <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <Grid container direction='row' alignItems="center">
                                            <img src={data.icon} alt='' className={classes.menuIcon} style={{ width: 40, height: 40 }} />
                                            <Grid>
                                                <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>{data.title}</Typography>
                                                <Typography style={{ color: '#FF4949', fontSize: 12, marginLeft: 15 }}>{data.content}</Typography>
                                            </Grid>
                                        </Grid>
                                    </ListItemIcon>
                                    <ListItemSecondaryAction>
                                        <ButtonBase variant="outlined" className={taskData[n]?taskData[n]['btn']:classes.taskBtn} onClick={() => { this._onListItemClick(n) }}>
                                            {taskData[n]?taskData[n]['name']:'做任务'}
                                        </ButtonBase>
                                    </ListItemSecondaryAction>
                                </ListItem>

                            ))
                        }
                    </List>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this._onSnackClosed()}
                    autoHideDuration={2000}
                >
                    <MySnackbarContentWrapper
                        className={classes.snackbar}
                        message={snackmessage}
                        variant={snackvariant}
                    />
                </Snackbar>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => (
    {
        img: {
            width: 355,
            height: 141,
            background: 'linear-gradient(to right, #ED8B5B, #F64152)',
            borderRadius: 10.5,
        },
        sureBtn: {
            backgroundColor: '#FFFFFF',
            borderRadius: 22.5,
            color: '#FF4949',
            height: 25,
            width: 60,
            margin: theme.spacing(1.3, 0, 0, 0),
            fontSize: 12,
        },
        taskBtn: {
            backgroundColor: '#FFFFFF',
            borderRadius: 22.5,
            color: '#FF4949',
            height: 25,
            width: 60,
            fontSize: 12,
            border: "solid 1px #FF4949",

        },
        taskBtn1: {
            background: 'linear-gradient(to right, #ED8B5B, #F64152)',
            borderRadius: 22.5,
            color: '#FFFFFF',
            height: 25,
            width: 60,
            fontSize: 12,
            
        },
        taskBtn2: {
            // backgroundColor: '#FFFFFF',
            // borderRadius: 22.5,
            color: '#898989',
            // height: 25,
            // width: 60,
            fontSize: 12,
            // border: "solid 1px #FF4949",
            
        },
        snackbar: {
            marginTop: '45vh',
        },
    }
))(WalletDialog));